import { gsap } from "gsap";
import { CustomEase } from "gsap/CustomEase";
gsap.registerPlugin(CustomEase);

const figBranch = document.querySelector('#fig-branch');

if(document.body.classList.contains('post-type-archive-press')){

	window.addEventListener('load', function () {

		figBranch.style.visibility = 'visible';

		// FLOWER - LEFT

		gsap.fromTo('#fig-branch',
			{
				xPercent:-55,
				rotation:20,
			},
			{
				xPercent:0,
				rotation:0,
				duration:3.5,
				ease: CustomEase.create("custom", "M0,0 C0.7,0 0.2,1 1,1 ")
			}
		);

	});

}